<template>
    <div>
        <div class="page-header ">
            <!--<div class="text-center ">
                <span class="text-uppercase page-subtitle">{{$t("REPORTS.SILO_DETAILS")}}</span>
            </div>-->
            <div class="text-center ">
                <span class="text-uppercase page-subtitle">{{$t("REPORTS.SILO_DETAILS")}} </span>
                </div>
        </div>

        <w-card size="100">                                                
            
            <el-row style="height: 100px" v-if="loadingSilos" v-loading="loadingSilos"/>

            <div class="row" v-if="!loadingSilos" >
               <div class="col-12  mb-4">
                    <div class="d-flex align-items-center">
                        <h5 class="font-weight-bold">{{detailsSiteName}}</h5><h6 class="text-muted ml-2 text-capitalize"> | </h6>
                        <h6 class="text-muted ml-2 text-capitalize">  </h6>
                        <h5>{{detailssiloName}}</h5>
                        <h6 class="text-muted ml-2 text-capitalize">({{$t('GRAIN.' + detailsType.toUpperCase()) }}) </h6>
                    </div>    
               
                    <siloImg :id="detailsId" :siteId="detailsSiteId"
                        :date="new Date(date)" :silo-name="detailssiloName" :siloColor="detailsSiloColor"/>   
                        
                                            
               </div>
            </div>
            
            <div class="row mt-md-4 mt-4">
                <div class="col-12 text-left">
                    <el-button type="primary" @click="$emit('close')">{{$t("COMMON.CLOSE")}}</el-button>
                </div>
            </div>

        </w-card>
    </div>
</template>

<script>
    import wCard from "./wCard";
    import siloImg from "./siloImg";

    export default {
        name: "ModalSiloImg",
        components: {
            "w-card": wCard,          
            "siloImg": siloImg
        },
        props: {
            id: {
                required: true,
                type: String
            },
            siteId: {
                required: true,
                type: String
            },
            date: {
                required: true,
                type: Date
            },
            siloName: {
                type: String,
                required: true,
            },
            siloType: {
                type: String,
                required: true,
            },

            siloColor :
            {
                required: true,
                type: Boolean
            },
            siteName:
            {
                required: true,
                type: String
            }
        },
        data: function () {
            return {
                detailsDate: undefined,
                detailsSiteId: undefined,
                detailsId: undefined,
                detailsSiloColor: undefined,
                detailssiloName: undefined,
                detailsType: undefined,
                detailsSiteName: undefined,
                loadingSilos: true,
            }
        },
        computed: {
            loadingSites: function () {
                return this.sites.length === 0 && this.userHasSites;
            },
        },
        watch: {

            siloColor: function()
            {

            },
            date(newDate) {
                console.info("Nueva fecha ", newDate);
            }
        },
          mounted() {
                this.detailsId = this.id;
                this.detailsSiteId = this.siteId;
                this.detailsSiloColor = this.siloColor;
                this.detailsDate = this.date;
                this.detailssiloName = this.siloName;
                this.detailsType = this.siloType;
                this.loadingSilos = false;
                this.detailsSiteName = this.siteName;
                //console.log("MOUNTED");
            },
        methods: {

        }

    }
</script>

<style>

</style>